import { j as s } from "./jsx-runtime-B6kdoens.js";
import { LoaderCircle as o } from "lucide-react";
const i = ({ size: r = 16 }) => /* @__PURE__ */ s.jsx(o, { size: r, className: "animate-spin" });
export {
  i as S
};
//# sourceMappingURL=Spinner-3cQDBVGr.js.map
